import { useAuthStore } from '@/stores/auth';

export class Module {
  can(moduleType) {
    if (!this._companyCheck()) {
      return false;
    }

    const module = this._getModule(moduleType);

    return Boolean(module && module.is_available_for_usage);
  }

  owned(moduleType) {
    if (!this._companyCheck()) {
      return false;
    }

    const module = this._getModule(moduleType);

    return Boolean(module && module.owned);
  }

  enabled(moduleType) {
    if (!this._companyCheck()) {
      return false;
    }

    const module = this._getModule(moduleType);

    return Boolean(module && module.enabled);
  }

  _companyCheck() {
    if (!this.getAuthStore().user) {
      return false;
    }

    return this.getAuthStore().user.activeCompany.enabled_modules;
  }

  _getModule(type) {
    return this.getAuthStore().user.activeCompany.enabled_modules.find(m => m.type === type);
  }

  getAuthStore() {
    return useAuthStore();
  }
}

export const moduleService = new Module();
